'use client';

import { ReactNode } from 'react';
import classnames from 'classnames';

import { useMenus } from '@personly/libs-providers';

interface Props {
  children: ReactNode;
}

const MenuLinks = ({ children }: Props) => {
  const { isOpen } = useMenus();

  const className = classnames({
    hidden: true,
    'flex-col': true,
    'lg:flex': true,
    '!flex': isOpen,
  });

  return <div className={className}>{children}</div>;
};

export default MenuLinks;
